export default "__VITE_ASSET__DOF3VYd4__"